import { useQuery } from "@tanstack/react-query";
import { getHotelRatingsForSelect } from "../../api/apiHotelRatings";
import i18next from "i18next";

const useGetHotelRatingsForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["HotelRatingsForSelect", i18next.language],
        queryFn: getHotelRatingsForSelect,
        staleTime: 1000 * 60 * 30,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetHotelRatingsForSelect;
